module.exports = __webpack_public_path__ + "static/media/mainimg-10.65fe1806.png";